import { FormArray, FormGroup } from "@angular/forms";
import { BmItemForm, BudgetModelFormGroup } from "../../../pojo/bm-form";
import { BmCalcType } from "../../../pojo/bm-enums";
import { BmPeriodEnum } from "../../../pojo/bm-classes";
import { BmCalcHelperService } from "../../general/bm-calc-helper.service";

export class BmTotalAccumulatedCapCalcService {

  /**
   * 1) Builds a flat array of total‐per‐period by summing all four sections totals at each period.
   * 2) Go thought: for quarters, adds to sum; for years, recalculate sum as the sum of all quarters up through that year.
   */
  public static recalculateTotalAccumulatedRequired(budgetForm: BudgetModelFormGroup): void {
    // do not change values in total commitment edit mode
    if (budgetForm.controls.totalCommitment.enabled) {
      return;
    }

    const totalCommitment = budgetForm.controls.totalCommitment.getRawValue() || 0;
    const valuesFA = budgetForm.controls.modelData.controls.totalCapAccumulated.controls.values;
    const pcntFA = budgetForm.controls.modelData.controls.totalCapAccumulated.controls.pcnt;
    const cumulativeTotals = this.prepareCumulativeTotals(budgetForm);

    // Calculate and patch total row value and pcnt
    const totalRow = budgetForm.controls.modelData.controls.totalCapRequired.controls.totalRow.getRawValue();

    const totalRowPcnt = totalCommitment > 0 ? (totalRow / totalCommitment) * 100 : 0;

    // Patch values
    cumulativeTotals.forEach((val, i) =>
      BmCalcHelperService.patchAndDisable(valuesFA.at(i), val, BmCalcType.GENERATED),
    );
    // Patch pcnt
    cumulativeTotals.forEach((val, i) => {
      const pct = totalCommitment > 0 ? (val / totalCommitment) * 100 : 0;
      BmCalcHelperService.patchAndDisable(pcntFA.at(i), pct, BmCalcType.GENERATED);
    });


    budgetForm.controls.modelData.controls.totalCapAccumulated.controls.totalRow.patchValue(totalRow, { emitEvent: false });
    budgetForm.controls.modelData.controls.totalCapAccumulated.controls.totalRowPcnt.patchValue(totalRowPcnt, { emitEvent: false });

    budgetForm.controls.unallocatedCommitment.patchValue(totalCommitment - totalRow);
    budgetForm.controls.unallocatedCommitment.disable({ emitEvent: false });
  }

  private static prepareCumulativeTotals(budgetForm: BudgetModelFormGroup): number[] {
    const bm = budgetForm.controls.modelData;

    const modelData = [
      bm.controls.mgmFee.controls.total,
      bm.controls.operatingExpenses.controls.total,
      bm.controls.organizationalExpenses.controls.total,
      bm.controls.investment.controls.itemsValue,
    ] as FormArray<FormGroup<any>>[];

    const periods = modelData[0].controls.map((item: FormGroup<BmItemForm>) => item.controls.period.value);

    const periodTotals = periods.map((_, i) =>
      modelData.reduce(
        (acc, src) => acc + Number(src.at(i).controls.itemValue.getRawValue() || 0),
        0
      )
    );

    // calculate cumulative values
    const cumulative: number[] = [];
    let sum = 0;

    periods.forEach((p, i) => {
      if (p.type === BmPeriodEnum.QUARTER) {
        sum += periodTotals[i];
      } else {
        sum = periods
          .map((per, j) => (per.type === BmPeriodEnum.QUARTER && per.yearNumber <= p.yearNumber ? periodTotals[j] : 0))
          .reduce((a, b) => a + b, 0);
      }
      cumulative[i] = sum;
    });

    return cumulative;
  }
}
